module.exports = __webpack_public_path__ + "img/gift-icon.cee04b88.svg";